import {
  staticText,
  brandSpecificStaticText,
  Translated,
} from '../../../utils/translations/staticText';
import money101Translation from './money101';
import moneyHeroTranslation from './moneyhero';
import moneyMaxTranslation from './moneymax';

export const SingleProductPromotionTranslations = staticText({
  sectionTitle: {
    _: 'Exclusive Rewards Worth Up to',
    zh: '獨家獎賞總值高達',
  },
  chooseSsReward: {
    _: '1. Choose Your SingSaver Reward',
    zh: '1. 選擇你的獎賞',
  },
  pickRewards: {
    _: 'Pick one of these rewards:',
    zh: '選擇以下其中一項獎賞：',
  },
  providerRewardTitle: {
    _: "2. Get the Provider's Own Reward",
    zh: '2. 獲取供應商獎賞',
  },
  providerRewardSubtitle: {
    _: 'On top of your {siteName} reward, {providerName} will also give you:',
    zh: '除了{siteName}獎賞外，{providerName}還會給你：',
  },
  howToApply: {
    _: 'How to Apply?',
    zh: '如何申請？',
  },
  showCampaignDetails: {
    _: 'Show Campaign Details',
    zh: '顯示活動詳情',
  },
  showMore: {
    _: 'Show More',
    zh: '顯示更多',
  },
  limitedTime: {
    _: 'Limited time',
    zh: '限時優惠',
  },
  limitedTimeEnds: {
    _: 'Limited time \u2022 Ends in {time}',
    zh: '限時優惠 \u2022 {time}後結束',
  },
  tncApply: {
    _: '*T&Cs apply for',
    zh: '*條款及細則適用於',
  },
  tncAnd: {
    _: 'and',
    zh: '及',
  },
  worth: {
    _: 'Worth',
    zh: '價值',
  },
  topUpOnly: {
    _: 'Top-up only',
    zh: '只需加付',
  },
  plTitle1: {
    _: 'For a {providerName} Personal Loan of {amount} over {tenure} months, you\u2019ll enjoy via {siteName}',
    zh: '申請{providerName}{amount}貸款，分{tenure}個月還款，透過{siteName}可享：',
  },
  plTitle2: {
    _: 'For other loan amounts and tenures you can choose from:',
    zh: '其他貸款金額和期限可選擇：',
  },
  yourApplicationQualifies: {
    _: 'Your application also qualifies you for:',
    zh: '你的申請同時符合以下資格：',
  },
  day: {
    _: '{count} day',
    zh: '{count}日',
  },
  days: {
    _: '{count} days',
    zh: '{count}日',
  },
  hour: {
    _: '{count} hour',
    zh: '{count}小時',
  },
  hours: {
    _: '{count} hours',
    zh: '{count}小時',
  },
  brand_reward_guidance: {
    _: "SingSaver's reward",
    zh: 'MoneyHero 獨家獎勵',
  },
  provider_reward_guidance: {
    _: ":Provider's reward",
    zh: ':Provider 獨家獎勵',
  },

  defaultGiftTenureLabel: {
    _: '',
    zh: '還款期',
  },
  defaultGiftTenureWithOutEndSuffix: {
    _: '',
    zh: '個月或以上',
  },
  defaultGiftTenureWithEndSuffix: {
    _: '',
    zh: '個月',
  },
  defaultGiftAmountLabel: {
    _: '',
    zh: '貸款額',
  },
  defaultGiftAmountSuffix: {
    _: 'and above',
    zh: '或以上',
  },
  reward_modal_loan_amount_with_end: {
    _: ':start - :end',
    zh: ':label :start - :end',
  },
  reward_modal_loan_amount_without_end: {
    _: ':start',
    zh: ':label :start',
  },
  reward_modal_tenure_with_end: {
    _: ':start - :end month tenure',
    zh: ':label :prefix:start :suffix - :prefix:end :suffix',
  },
  reward_modal_tenure_without_end: {
    _: ':start month tenure :suffix',
    zh: ':label :start :suffix',
  },
});

export const TRANSLATIONS = brandSpecificStaticText({
  _: SingleProductPromotionTranslations,
  moneyhero: moneyHeroTranslation,
  money101: money101Translation,
  moneymax: moneyMaxTranslation,
});

export type SingleProductPromotionText = typeof TRANSLATIONS;
export type StaticText = Translated<typeof TRANSLATIONS>;
